var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 11.5H13.4531C12.6562 11.5 12 12.2031 12 13.0469V31C12 31.8438 12.6562 32.5 13.4531 32.5H31.5C32.2969 32.5 33 31.8438 33 31V13.0469C33 12.2031 32.2969 11.5 31.5 11.5ZM18.3281 29.5H15.2344V19.5156H18.3281V29.5ZM16.7812 18.1094C15.75 18.1094 14.9531 17.3125 14.9531 16.3281C14.9531 15.3438 15.75 14.5 16.7812 14.5C17.7656 14.5 18.5625 15.3438 18.5625 16.3281C18.5625 17.3125 17.7656 18.1094 16.7812 18.1094ZM30 29.5H26.8594V24.625C26.8594 23.5 26.8594 22 25.2656 22C23.625 22 23.3906 23.2656 23.3906 24.5781V29.5H20.2969V19.5156H23.25V20.875H23.2969C23.7188 20.0781 24.75 19.2344 26.25 19.2344C29.3906 19.2344 30 21.3438 30 24.0156V29.5Z",
    fill: "#45B549"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.0fb85eef8fa43bbabe28df086d8b7185.svg";
export { ForwardRef as ReactComponent };